import { useState } from 'react';
import useResizeObserver from 'use-resize-observer';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function useIsClamped(ref?: any): boolean {
    const [isClamped, setIsClamped] = useState(ref?.current ? ref.current.scrollHeight > ref.current.clientHeight : false);

    useResizeObserver({
        ref,
        onResize: () => {
            setTimeout(() => {
                if (ref?.current) {
                    setIsClamped(ref.current.scrollHeight > ref.current.clientHeight);
                }
            }, 0);
        },
    });

    return isClamped;
}

export default useIsClamped;
